import { variables, blocks, element, editor, blockEditor, i18n } from '../common/variables';

const cl = (e) => { console.log(e) };

const makeShortcodeString = (attributes) => {
  cl(attributes);
  let shortcodeString = '[map ';

  attributes.title !== '' ? shortcodeString += `title="${attributes.title}" ` : shortcodeString += '';
  attributes.geolocation !== false ? shortcodeString += `geolocalisation="${attributes.geolocation}" ` : shortcodeString += '';
  attributes.types !== '' ? shortcodeString += `type="${attributes.types}" ` : shortcodeString += '';
  attributes.display !== '' ? shortcodeString += `template="${attributes.display}" ` : shortcodeString += '';
  if (attributes.display === 'full') {
    attributes.filters !== true ? shortcodeString += `filters="${attributes.filters}" ` : shortcodeString += '';
    attributes.search !== '' ? shortcodeString += `search-type="${attributes.search}" ` : shortcodeString += '';
    if (attributes.search === 'leaflet') {
      attributes.searchLanguage !== '' ? shortcodeString += `search-language="${attributes.searchLanguage}" ` : shortcodeString += '';
      attributes.searchCountry !== '' ? shortcodeString += `search-country="${attributes.searchCountry}" ` : shortcodeString += '';
    }
  }

  shortcodeString += ']';
  return shortcodeString;
}

export { cl, makeShortcodeString }
